import React, { useState } from 'react';
import AdminNavbar from '../components/AdminNavbar';
import { ArrowPathIcon } from '@heroicons/react/24/outline';
import { syncSRAData } from '../services/organisationService';

const SyncPage = () => {
    const [syncing, setSyncing] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    const handleSync = async () => {
        setSyncing(true);
        setError(null);
        setSuccess(false);
        try {
            await syncSRAData();
            setSuccess(true);
        } catch (error) {
            console.error('Error syncing data:', error);
            setError(error.response?.data?.details || 'Failed to sync SRA data');
        } finally {
            setSyncing(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-100">
            <AdminNavbar />
            <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                <div className="px-4 sm:px-0 mb-6">
                    <h1 className="text-2xl font-semibold text-gray-900 mb-0">SRA Data Synchronization</h1>
                    <p className="mt-1 text-sm text-gray-600">
                        Synchronize data with the Solicitors Regulation Authority database.
                    </p>
                </div>

                <div className="bg-white shadow rounded-lg p-6">
                    {error && (
                        <div className="mb-6 p-4 bg-red-50 border border-red-200 text-red-700 rounded-md">
                            <p className="font-medium">Synchronization Error</p>
                            <p className="text-sm">{error}</p>
                        </div>
                    )}

                    {success && (
                        <div className="mb-6 p-4 bg-green-50 border border-green-200 text-green-700 rounded-md">
                            <p className="font-medium">Success!</p>
                            <p className="text-sm">Data synchronized successfully with the SRA database.</p>
                        </div>
                    )}

                    <div className="flex items-center justify-between">
                        <div className="flex-1 max-w-2xl">
                            <h2 className="text-lg font-medium text-gray-900 mb-2">Manual Sync</h2>
                            <p className="text-sm text-gray-600 mb-4">
                                Click the button below to manually synchronize data with the SRA database. 
                                This process may take a few minutes to complete.
                            </p>
                        </div>
                        <button
                            onClick={handleSync}
                            disabled={syncing}
                            className={`btn btn--primary inline-flex items-center ${syncing ? 'opacity-75 cursor-not-allowed' : ''}`}
                        >
                            <ArrowPathIcon className={`h-5 w-5 mr-2 ${syncing ? 'animate-spin' : ''}`} />
                            {syncing ? 'Syncing...' : 'Sync SRA Data'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SyncPage;